import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from 'src/app/infrastructure/routes';
import { ConsigneeNotifierAdminGateway } from '../gateway/ConsigneeNotifierAdminGateway';
import { ConsigneeNotifierAdmin } from 'src/app/domain/models/ConsigneeNotifierAdmin';

@Injectable({ providedIn: 'root' })
export class ConsigneeNotifierAdminService extends ConsigneeNotifierAdminGateway {

  constructor(private _http: HttpClient) {
    super();
  }

  getRequestFile(request: any) {
    const formData = new FormData();

    if (request) {
      if (request.file) formData.append('file', request.file);
    }
    return formData;
  }

  uploadConsigneesNotifiers(request: any): Observable<any> {
    return this._http.post(
      Routes.consigneeNotifierAdminApi + '/Import',
      this.getRequestFile(request)
    );
  }

  override getAllByCountryIdAndType(
    countryId: number,
    type: string
  ): Observable<ConsigneeNotifierAdmin[]> {
    return this._http.get<ConsigneeNotifierAdmin[]>(
      Routes.consigneeNotifierAdminApi + '/GetAllByCountryAndType',
      { params: { countryId, type } }
    );
  }

  override assignUser(request: any): Observable<any> {
    return this._http.post(
      Routes.consigneeNotifierAdminApi + '/AssignUser',
      request
    );
  }

  override CreateConsigneeOrNotifierFromUser(request: any): Observable<any> {
    return this._http.post(
      Routes.consigneeNotifierAdminApi + '/CreateConsigneeOrNotifierFromUser',
      request
    );
  }

  override exportConsigneesNotifiers(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream',
    });
    return this._http.get(Routes.consigneeNotifierAdminApi + '/Export', {
      headers: headers,
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
